// extracted by mini-css-extract-plugin
module.exports = {"smjtouk":"smjtouk"};